import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NavimumbaitoshirdiTaxiFare() {



    const cardData = {





keyword: "Navi Mumbai to Shirdi Taxi Fare",

headingDescription: "Shreesha Tours & Travels provides affordable Navi Mumbai to Shirdi Taxi Fare with comfortable and reliable cab services for Sai Baba devotees, families, corporate travelers, and tourists. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way trips, round trips, airport transfers, and customized pilgrimage tours. Our taxi fares are transparent with no hidden charges, ensuring excellent value for long-distance travel. With experienced drivers, clean and well-maintained vehicles, doorstep pickup, flexible travel schedules, and 24/7 customer support, we guarantee a safe, comfortable, and hassle-free journey from Navi Mumbai to Shirdi. Whether you are planning a same-day darshan, weekend pilgrimage, or family vacation, Shreesha Tours & Travels offers dependable cab booking services at competitive prices.",

topPlaces: [
  {
    title: "Sai Baba Samadhi Temple",
    description: "The Sai Baba Samadhi Temple is Shirdi's most sacred attraction, where millions of devotees visit every year to seek blessings and attend the daily aarti."
  },
  {
    title: "Dwarkamai",
    description: "Dwarkamai is the holy mosque where Sai Baba spent many years of his life. It is one of the most spiritually significant places in Shirdi."
  },
  {
    title: "Chavadi",
    description: "Chavadi is an important religious site where Sai Baba used to stay on alternate nights. It remains a major attraction for devotees."
  },
  {
    title: "Gurusthan",
    description: "Gurusthan is believed to be the place where Sai Baba was first seen as a young saint. It is an important spiritual landmark in Shirdi."
  },
  {
    title: "Lendi Baug",
    description: "Lendi Baug is a peaceful garden created by Sai Baba where devotees visit for meditation, prayer, and spiritual peace."
  },
  {
    title: "Shani Shingnapur",
    description: "Located near Shirdi, Shani Shingnapur is famous for the temple of Lord Shani and is frequently included in Shirdi pilgrimage tours."
  },
  {
    title: "Trimbakeshwar Jyotirlinga",
    description: "Trimbakeshwar is one of the twelve Jyotirlingas of Lord Shiva and a popular pilgrimage destination often combined with a Shirdi trip."
  },
  {
    title: "Sula Vineyards Nashik",
    description: "Sula Vineyards offers vineyard tours, wine tasting, scenic landscapes, and premium dining, making it a popular stop while traveling in the Nashik region."
  },
  {
    title: "Panchavati Nashik",
    description: "Panchavati is a sacred destination associated with the Ramayana, featuring Ramkund, Kalaram Temple, Sita Gufa, and several important religious sites."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a picturesque hill destination known for Arthur Lake, Randha Waterfall, Wilson Dam, and peaceful natural surroundings, perfect for a relaxing detour."
  }
],


"services": [
  {
    "name": "Navi Mumbai to Shirdi Taxi Fare",
    "description": "Get affordable Navi Mumbai to Shirdi Taxi Fare with transparent pricing, no hidden charges, and comfortable AC vehicles. Choose from Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and Tempo Traveller for a safe and convenient journey."
  },
  {
    "name": "Mumbai to Shirdi Cab",
    "description": "Book Mumbai to Shirdi Cab for comfortable temple travel with professional chauffeurs, well-maintained AC vehicles, and one-way or round-trip travel options for families, pilgrims, and groups."
  },
  {
    "name": "Mumbai to Shirdi Taxi",
    "description": "Choose Mumbai to Shirdi Taxi for reliable and affordable transportation with experienced drivers, clean vehicles, and doorstep pickup and drop services."
  },
  {
    "name": "Mumbai to Shirdi Taxi Fare",
    "description": "Get the best Mumbai to Shirdi Taxi Fare with competitive pricing, flexible vehicle options, and dependable chauffeur-driven taxi services."
  },
  {
    "name": "Mumbai to Shirdi Car Rental",
    "description": "Reserve Mumbai to Shirdi Car Rental with driver for convenient religious travel, family trips, and comfortable long-distance journeys at affordable rates."
  },
  {
    "name": "Mumbai to Shirdi Taxi Service",
    "description": "Book Mumbai to Shirdi Taxi Service for safe, punctual, and comfortable travel with experienced chauffeurs and premium AC vehicles."
  },
  {
    "name": "Mumbai to Shirdi Taxi Innova Fare",
    "description": "Check Mumbai to Shirdi Taxi Innova Fare for spacious family travel with comfortable seating, luggage space, and transparent pricing."
  },
  {
    "name": "Mumbai to Shirdi Cab Service",
    "description": "Choose Mumbai to Shirdi Cab Service for reliable one-way and round-trip transportation with professional drivers and clean AC vehicles."
  },
  {
    "name": "Mumbai Airport to Shirdi Taxi",
    "description": "Book Mumbai Airport to Shirdi Taxi for direct airport pickup with flight tracking, luggage assistance, and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Shirdi Taxi Price",
    "description": "Get affordable Mumbai to Shirdi Taxi Price with transparent rates, multiple vehicle options, and quality travel services."
  },
  {
    "name": "Mumbai to Shirdi Cab Fare",
    "description": "Compare Mumbai to Shirdi Cab Fare and choose from economical Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV cab options."
  },
  {
    "name": "Book Taxi from Mumbai to Shirdi",
    "description": "Book Taxi from Mumbai to Shirdi online with instant confirmation, experienced chauffeurs, flexible pickup timings, and 24x7 customer support."
  },
  {
    "name": "Innova from Mumbai to Shirdi",
    "description": "Reserve Innova from Mumbai to Shirdi for spacious family travel, religious tours, and comfortable long-distance transportation."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking",
    "description": "Choose Mumbai to Shirdi Cab Booking for secure online reservations, transparent pricing, and professional chauffeur-driven travel."
  },
  {
    "name": "Navi Mumbai to Shirdi Cab Fare",
    "description": "Get affordable Navi Mumbai to Shirdi Cab Fare with reliable taxi services, comfortable vehicles, and experienced drivers."
  },
  {
    "name": "Navi Mumbai to Shirdi Taxi Price",
    "description": "Check Navi Mumbai to Shirdi Taxi Price for budget-friendly travel with multiple cab categories and transparent pricing."
  },
  {
    "name": "Navi Mumbai to Shirdi Cab Price",
    "description": "Book Navi Mumbai to Shirdi Cab Price with affordable packages, professional chauffeurs, and clean AC vehicles."
  },
  {
    "name": "Taxi Fare from Navi Mumbai to Shirdi",
    "description": "Find Taxi Fare from Navi Mumbai to Shirdi with competitive rates, dependable taxi services, and comfortable travel options."
  },
  {
    "name": "Shirdi Taxi Fare from Navi Mumbai",
    "description": "Choose Shirdi Taxi Fare from Navi Mumbai for economical pilgrimage travel with transparent pricing and quality chauffeur-driven vehicles."
  },
  {
    "name": "Cab Charges Navi Mumbai to Shirdi",
    "description": "Get Cab Charges Navi Mumbai to Shirdi with fair pricing, flexible vehicle options, and reliable transportation services."
  },
  {
    "name": "Navi Mumbai to Shirdi Cab Charges",
    "description": "Check Navi Mumbai to Shirdi Cab Charges for affordable one-way and round-trip travel with experienced drivers."
  },
  {
    "name": "Cheapest Taxi Navi Mumbai to Shirdi",
    "description": "Book the Cheapest Taxi Navi Mumbai to Shirdi for budget-friendly temple travel with clean AC vehicles and dependable chauffeur service."
  },
  {
    "name": "Best Taxi Fare Navi Mumbai to Shirdi",
    "description": "Choose the Best Taxi Fare Navi Mumbai to Shirdi for premium travel at competitive prices with professional drivers and comfortable vehicles."
  },
  {
    "name": "One Way Taxi Fare Navi Mumbai to Shirdi",
    "description": "Reserve One Way Taxi Fare Navi Mumbai to Shirdi for economical drop taxi services without return charges."
  },
  {
    "name": "Round Trip Taxi Fare Navi Mumbai to Shirdi",
    "description": "Book Round Trip Taxi Fare Navi Mumbai to Shirdi for family visits, Sai Baba Darshan, and return travel with flexible schedules."
  },
  {
    "name": "Outstation Taxi Fare Navi Mumbai to Shirdi",
    "description": "Choose Outstation Taxi Fare Navi Mumbai to Shirdi for long-distance travel with premium vehicles, professional chauffeurs, and transparent pricing."
  },
  {
    "name": "Innova Taxi Fare Navi Mumbai to Shirdi",
    "description": "Check Innova Taxi Fare Navi Mumbai to Shirdi for spacious family travel with premium comfort and affordable pricing."
  },
  {
    "name": "Innova Crysta Fare Navi Mumbai to Shirdi",
    "description": "Book Innova Crysta Fare Navi Mumbai to Shirdi for luxury travel with premium interiors, spacious seating, and professional chauffeur service."
  },
  {
    "name": "Ertiga Taxi Fare Navi Mumbai to Shirdi",
    "description": "Reserve Ertiga Taxi Fare Navi Mumbai to Shirdi for affordable family transportation with comfortable seating and reliable drivers."
  },
  {
    "name": "Sedan Taxi Fare Navi Mumbai to Shirdi",
    "description": "Choose Sedan Taxi Fare Navi Mumbai to Shirdi for economical travel with clean AC sedan cars and experienced chauffeurs."
  },
  {
    "name": "SUV Taxi Fare Navi Mumbai to Shirdi",
    "description": "Book SUV Taxi Fare Navi Mumbai to Shirdi for spacious travel with extra luggage capacity, premium comfort, and reliable chauffeur-driven service."
  }
],
"tableData": [
  ["Navi Mumbai to Shirdi Taxi Fare", "Mumbai to Shirdi Cab"],
  ["Mumbai to Shirdi Taxi", "Mumbai to Shirdi Taxi Fare"],
  ["Mumbai to Shirdi Car Rental", "Mumbai to Shirdi Taxi Service"],
  ["Mumbai to Shirdi Taxi Innova Fare", "Mumbai to Shirdi Cab Service"],
  ["Mumbai Airport to Shirdi Taxi", "Mumbai to Shirdi Taxi Price"],
  ["Mumbai to Shirdi Cab Fare", "Book Taxi from Mumbai to Shirdi"],
  ["Innova from Mumbai to Shirdi", "Mumbai to Shirdi Cab Booking"],
  ["Navi Mumbai to Shirdi Cab Fare", "Navi Mumbai to Shirdi Taxi Price"],
  ["Navi Mumbai to Shirdi Cab Price", "Taxi Fare from Navi Mumbai to Shirdi"],
  ["Shirdi Taxi Fare from Navi Mumbai", "Cab Charges Navi Mumbai to Shirdi"],
  ["Navi Mumbai to Shirdi Cab Charges", "Cheapest Taxi Navi Mumbai to Shirdi"],
  ["Best Taxi Fare Navi Mumbai to Shirdi", "One Way Taxi Fare Navi Mumbai to Shirdi"],
  ["Round Trip Taxi Fare Navi Mumbai to Shirdi", "Outstation Taxi Fare Navi Mumbai to Shirdi"],
  ["Innova Taxi Fare Navi Mumbai to Shirdi", "Innova Crysta Fare Navi Mumbai to Shirdi"],
  ["Ertiga Taxi Fare Navi Mumbai to Shirdi", "Sedan Taxi Fare Navi Mumbai to Shirdi"],
  ["SUV Taxi Fare Navi Mumbai to Shirdi", ""]
],




whychoose: [
  {
    WhyChooseheading: "Affordable Navi Mumbai to Shirdi Taxi Service",
    WhyChoosedescription: "Planning a spiritual journey to Shirdi? Shreesha Travels provides reliable Navi Mumbai to Shirdi taxi services with transparent pricing, comfortable vehicles, and experienced chauffeurs for a safe and peaceful travel experience."
  },
  {
    WhyChooseheading: "Taxi Fare with Flexible Travel Options",
    WhyChoosedescription: "Our Navi Mumbai to Shirdi taxi fare is based on the selected vehicle, travel distance, trip type, toll charges, and itinerary, ensuring fair pricing without hidden costs."
  },
  {
    WhyChooseheading: "Choose the Ideal Vehicle for Your Journey",
    WhyChoosedescription: "Select from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles for individuals, families, and larger groups."
  },
  {
    WhyChooseheading: "Perfect for Sai Baba Darshan & Family Pilgrimages",
    WhyChoosedescription: "Our Navi Mumbai to Shirdi taxis are suitable for Sai Baba Temple visits, family pilgrimages, senior citizen travel, religious tours, and customized Maharashtra temple circuits."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Packages",
    WhyChoosedescription: "Book a one-way taxi to Shirdi or choose a round-trip package with return flexibility, waiting options, and additional sightseeing stops if required."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway Routes",
    WhyChoosedescription: "Our trained chauffeurs are familiar with the Navi Mumbai–Shirdi highway route and ensure safe driving, punctual pickups, and a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, sanitized, air-conditioned, and inspected before departure, offering passengers a clean and dependable travel experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai to Shirdi Taxi with Shreesha Travels",
    WhyChoosedescription: "Get competitive taxi fares, instant booking support, professional chauffeur service, and reliable transportation for your Shirdi pilgrimage or personal journey."
  }
]

};

const faqData = [
  {
    question: "How is the Navi Mumbai to Shirdi taxi fare calculated?",
    answer: "The taxi fare depends on the selected vehicle, travel distance, one-way or round-trip requirement, toll charges, waiting time, and travel itinerary."
  },
  {
    question: "Can I book a one-way taxi from Navi Mumbai to Shirdi?",
    answer: "Yes, one-way taxi services are available for direct travel from Navi Mumbai to Shirdi."
  },
  {
    question: "Which vehicles are available for Shirdi travel?",
    answer: "We offer Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Do you provide round-trip taxi packages to Shirdi?",
    answer: "Yes, round-trip taxi services are available with flexible return schedules and waiting options."
  },
  {
    question: "Is this taxi service suitable for senior citizens visiting Shirdi?",
    answer: "Yes, our comfortable vehicles and experienced chauffeurs make the journey convenient for senior citizens and families."
  },
  {
    question: "Can I include Shani Shingnapur during my Shirdi trip?",
    answer: "Yes, customized travel plans can include Shani Shingnapur and other nearby pilgrimage destinations."
  },
  {
    question: "Are early morning departures available?",
    answer: "Yes, you can schedule your pickup according to your preferred departure time, including early morning travel."
  },
  {
    question: "Do your fares include toll and parking charges?",
    answer: "Fare inclusions depend on the selected package. Our team will clearly explain all applicable charges before confirming your booking."
  },
  {
    question: "Can I book a taxi for a same-day Shirdi return trip?",
    answer: "Yes, same-day return taxi packages can be arranged depending on your travel schedule."
  },
  {
    question: "How can I get the best Navi Mumbai to Shirdi taxi fare from Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger count, preferred vehicle, and trip type to receive a customized quotation with the best available fare."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Kulkarni",
    feedback: "The taxi fare was reasonable, and the service exceeded our expectations. The vehicle was clean, the driver was courteous, and our Shirdi trip was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rekha Patil",
    feedback: "Excellent Shirdi taxi service from Navi Mumbai. Transparent pricing, punctual pickup, and a smooth journey made our pilgrimage peaceful and enjoyable.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Shirdi Taxi Fare",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-to-shirdi-taxi-fare.webp",
  "description":
    "Book Navi Mumbai to Shirdi Taxi with Shreesha Tours & Travels for comfortable and reliable pilgrimage taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Sai Baba Darshan, family trips, religious tours, one-way, round-trip, and long-distance journeys from Navi Mumbai to Shirdi with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-to-shirdi-taxi-fare"
  }
};


    return (
        <div>
<Helmet>
  <title>Navi Mumbai to Shirdi Taxi Fare | Shirdi Cab Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Shirdi Taxi with Shreesha Travels for safe and comfortable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Sai Baba Darshan, one-way trips, round trips, family travel, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to Shirdi Taxi Fare, Mumbai to Shirdi Cab, Mumbai to Shirdi Taxi, Mumbai to Shirdi Taxi Fare, Mumbai to Shirdi Car Rental, Mumbai to Shirdi Taxi Service, Mumbai to Shirdi Taxi Innova Fare, Mumbai to Shirdi Cab Service, Navi Mumbai to Shirdi Cab, Shirdi Darshan Taxi from Mumbai, One Way Cab Mumbai to Shirdi, Shirdi Tour Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NavimumbaitoshirdiTaxiFare;